module.exports = __webpack_public_path__ + "static/media/wingDox_news.a74ddca8.png";